export const preparationRoutes = [
  {
    path: "/retailers/:retailerId/packaging/:id/print",
    name: "packaging.print.index",
    component: () => import("@/views/preparation/PreparationPrinterPage.vue"),
    meta: {
      title: "Print",
      printersList: true,
      ability: { action: "create", subject: "Preparation" },
    },
  },
  {
    path: "/retailers/:retailerId/packaging/:id/scan",
    name: "packaging.rescan.index",
    component: () =>
      import("@/views/preparation/PreparationScanUpdatePage.vue"),
    meta: {
      title: "Scan",
      printersList: true,
      ability: { action: "create", subject: "Preparation" },
    },
  },
  {
    path: "/retailers/packaging/choose",
    name: "packaging.retailers.index",
    component: () =>
      import("@/views/preparation/PreparationRetailersPage.vue"),
    meta: {
      title: "Retailers",
      printersList: true,
      ability: { action: "create", subject: "Preparation" },
    },
  },
  {
    path: "/retailers/:retailerId/packaging/scan",
    name: "packaging.scan.index",
    icon: "search",
    component: () =>
      import("@/views/preparation/PreparationScanCreatePage.vue"),
    meta: {
      title: "Scan",
      printersList: true,
      ability: { action: "create", subject: "Preparation" },
    },
  },
];
